import './ReferralLinkItem.sass';

import React, { FC, MouseEvent, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslator } from '$hooks';
import { ReferralLinkItemProps } from '$core/ReferralsLinks/ReferralLinkItem/ReferralLinkItem.interface';
import { classNames as cn } from '$utils';
import { IcCheck28, IcCopy20 } from '$assets';

export const ReferralLinkItem: FC<ReferralLinkItemProps> = ({
  name,
  link,
  userId,
  id,
  onCopy,
  onClick,
  highlight,
}) => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
      onCopy(link);
    },
    [link, setIsCopied, onCopy],
  );

  return (
    <div className={cn('ReferralLinkItem', { highlight })} onClick={() => onClick(id)}>
      <div className="ReferralLinkItem__content">
        <div className="ReferralLinkItem__title">{name}</div>
        <div className="ReferralLinkItem__description">{link}</div>
      </div>
      <div onClick={handleCopy} className="ReferralLinkItem__copyLink">
        {isCopied ? <IcCheck28 /> : <IcCopy20 />}
      </div>
    </div>
  );
};
